export class ComletedStartControl {
    public supplierID: string;
    public supplierWorktimeControlID: string;
    public photoUrl: string;
    public additionalInfo: string;
}
